import { DonorReportOutput, DonorStatus } from 'gql/types';
import { TFunction } from 'i18next';
import { ReportFilterOptions } from 'modules/reports/hooks/useReportFilterOptions';
import { ReportFilterValues } from 'modules/reports/hooks/useReportFilters';
import { ReportFilterConfig } from 'modules/reports/types';

export const DONOR_REPORT_DEFAULT_FILTERS: ReportFilterValues = {
  excludeStatuses: [
    DonorStatus.Archived,
    DonorStatus.Retired,
    DonorStatus.NotAccepted,
  ],
};

export const getDonorReportFilters = (
  t: TFunction,
  { regionNames, locationNames }: ReportFilterOptions
): ReportFilterConfig<DonorReportOutput>[] => [
  {
    key: 'region',
    label: t('region'),
    type: 'multiselect',
    getValue: (item) => item.region,
    options: regionNames,
  },
  {
    key: 'location',
    label: t('location'),
    type: 'multiselect',
    getValue: (item) => item.location,
    options: locationNames,
  },
  {
    key: 'status',
    label: t('status'),
    type: 'multiselect',
    getValue: (item) => item.status,
    options: Object.values(DonorStatus),
  },
  {
    key: 'excludeStatuses',
    label: t('excludeStatuses'),
    type: 'multiselect',
    exclude: true,
    getValue: (item) => item.status,
    options: Object.values(DonorStatus),
  },
  {
    key: 'becameReservedDonorDate',
    label: t('registrationDate'),
    type: 'dateRange',
    getValue: (item) => item.becameReservedDonorDate,
  },
];
